import React, { Component } from "react";
import { Link } from "react-router-dom";
import { importImages, truncate } from "../../utils/helpers";

import styles from "./news-item.module.scss";

const thumbnails = importImages(
	require.context("../../images/news", false, /\.(jpe?g)$/)
);

const NewsItem = props => (
	<div className={props.className}>
		<div
			className={"col-12 col-md-5 col-lg-4 " + styles.featured_img}
			style={{
				backgroundImage: "url(https:"+props.featured_img.resolutions.src+")"
			}}
		/>
		<div className={"col-12 col-md-7 col-lg-8 " + styles.post}>
			<Link to={props.category_url} className={styles.post_category}>
				{props.category}
			</Link>

			<h3 className={styles.post_title}>
				{props.url ? (
					<Link to={props.url}>{truncate(props.title, 58, true)}</Link>
				) : (
					truncate(props.title, 58, true)
				)}
			</h3>
			<p className={styles.post_excerpt}>
				{props.excerpt}

				{props.url && (
					<Link to={props.url} style={{ display: "block" }}>
						Read more &raquo;
					</Link>
				)}
			</p>

			<span className={styles.post_date}>{props.published}</span>
		</div>
	</div>
);

export default NewsItem;



// WEBPACK FOOTER //
// ./src/components/news-item/index.js